import { Component, Input, inject } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { Store } from "@ngrx/store";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogTitle,
  MatDialogActions
} from "@angular/material/dialog";
import { Router } from "@angular/router";
import { SkillProfile } from "@app/models/rest/skill-profile";
import { SkillProfileStore } from "@app/services/store/skill-profile-store";
import { MatIcon } from "@angular/material/icon";
import { MatFormField, MatLabel, MatError } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-skill-profile-add",
  templateUrl: "./skill-profile-add.component.html",
  styleUrls: ["./skill-profile-add.component.scss"],
  imports: [
    MatDialogTitle,
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    MatError,
    MatDialogActions,
    MatButton,
    TranslatePipe
  ]
})
export class SkillProfileAddComponent {
  skillProfileStore = inject(SkillProfileStore);
  protected store = inject<Store<any>>(Store);
  protected dialog = inject(MatDialog);
  protected router = inject(Router);
  dialogRef = inject<MatDialogRef<SkillProfileAddComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  skillProfileForm = new UntypedFormGroup({
    skillProfileNameFC: new UntypedFormControl("")
  });

  @Input()
  skillProfile: SkillProfile;

  // getErrorMessage(controlName: string) {
  //   console.log(this.teamForm.controls[teamNameFC].errors);
  //   console.log('get error');
  //   return this.teamForm.controls[teamNameFC].errors.server;
  // }

  addSkillProfile(): void {
    const skillProfile: SkillProfile = new SkillProfile();

    skillProfile.description =
      this.skillProfileForm.controls["skillProfileNameFC"].value;

    this.skillProfileStore.create(skillProfile).subscribe(
      (value) => {
        console.log("success");
        this.dialogRef.close({ success: true });
      },
      (error) => {
        console.log("error");
        console.log(error);
        // alert(error.error.message)
      }
    );
  }

  onCancelClick() {
    this.dialogRef.close();
  }
}
